"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Divider_1 = require("../../../atoms/Divider/Divider");
var MenuItem_1 = require("../../../atoms/MenuItem/MenuItem");
var Popover_1 = require("../../../atoms/Popover/Popover");
var Typography_1 = require("../../../atoms/Typography/Typography");
var FilterDropdownButton_1 = require("../../../molecules/FilterDropdownButton/FilterDropdownButton");
var EditorToolbar_logic_1 = require("./EditorToolbar.logic");
var EditorToolbarIcon_1 = __importDefault(require("./EditorToolbarIcon/EditorToolbarIcon"));
var EditorToolbar = function () {
    var _a = (0, EditorToolbar_logic_1.useEditorToolbar)(), anchorElement = _a.anchorElement, classes = _a.classes, closeStyleMenu = _a.closeStyleMenu, toolbarOtherIcons = _a.toolbarOtherIcons, isExpanded = _a.isExpanded, openStyleMenu = _a.openStyleMenu, styleButtonMenuText = _a.styleButtonMenuText, styleMenuOptions = _a.styleMenuOptions, toolbarActionIcons = _a.toolbarActionIcons, toolbarBlockIcons = _a.toolbarBlockIcons, toolbarMarkIcons = _a.toolbarMarkIcons;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.root }, { children: [toolbarActionIcons.map(renderIcon), renderDivider(), renderStyleMenu(), renderDivider(), toolbarMarkIcons.map(renderIcon), renderDivider(), toolbarBlockIcons.map(renderIcon), renderDivider(), toolbarOtherIcons.map(renderIcon)] })));
    function renderIcon(_a) {
        var key = _a.key, props = __rest(_a, ["key"]);
        return (0, jsx_runtime_1.jsx)(EditorToolbarIcon_1.default, __assign({}, props), key);
    }
    function renderDivider() {
        return ((0, jsx_runtime_1.jsx)(Divider_1.Divider, { vertical: true, margin: {
                top: 0,
                left: 6,
                right: 6,
                bottom: 0,
            }, className: classes.divider }));
    }
    function renderStyleMenu() {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(FilterDropdownButton_1.FilterDropdownButton, { isExpanded: isExpanded, onMouseDown: openStyleMenu, title: styleButtonMenuText, className: classes.dropdownRoot }), (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({ anchorElement: anchorElement, closePopover: closeStyleMenu, popoverOffset: 16, popoverPosition: 'bottom left' }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.dropdown }, { children: styleMenuOptions.map(function (_a) {
                            var key = _a.key, onClick = _a.onClick, isActive = _a.isActive, bold = _a.bold, variant = _a.variant, text = _a.text;
                            return ((0, jsx_runtime_1.jsx)(MenuItem_1.MenuItem, __assign({ onClick: onClick, selectable: true, selected: isActive, disablePadding: true, className: classes.item }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ bold: bold, variant: variant }, { children: text })) }), key));
                        }) })) }))] }));
    }
};
exports.default = EditorToolbar;
